import { loadLanguagePreference } from '@/lib/i18n';

export function authHeaders(): Record<string, string> {
  const token =
    typeof window !== 'undefined'
      ? localStorage.getItem('apiAccessToken')
      : null;
  const headers: Record<string, string> = {};
  const language = loadLanguagePreference();
  if (language) headers['Accept-Language'] = language;
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}
